import React, { useEffect, useState } from 'react';
import { getCachedProtectedBlob } from '../../../../api/frontendCache';
import ChatImage from './ChatImage';

const ProtectedImage = ({ url, alt, className }) => {
  const [src, setSrc] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let objectUrl = null;
    let cancelled = false;

    const loadImage = async () => {
      try {
        const blob = await getCachedProtectedBlob(url);
        objectUrl = URL.createObjectURL(blob);

        if (!cancelled) {
          setSrc(objectUrl);
        }
      } catch (e) {
        console.error('Ошибка загрузки защищённого изображения:', e);
        if (!cancelled) {
          setError(true);
        }
      }
    };

    if (url) {
      loadImage();
    }

    return () => {
      cancelled = true;
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [url]);

  if (error) {
    return <div className="message-attachment-error">Не удалось загрузить изображение</div>;
  }

  if (!src) {
    return <div className="message-attachment-pending">Загрузка изображения...</div>;
  }

  return <ChatImage src={src} alt={alt} className={className} />;
};

export default ProtectedImage;
